import React, {useEffect, useRef, useState} from "react";
import {Button, Table, Tooltip, Typography} from "antd";
import {CheckOutlined, CopyOutlined} from "@ant-design/icons";
import {NotesResponse} from "../../../../../services/oneButtonServices/opportunityValidationService";
import {renderPairItem} from "./OpportunityValidationShared";

interface NotesProps {
    notes: NotesResponse;
}

export const Notes: React.FC<NotesProps> = ({notes}) => {
    const salesQualificationNotes = notes.sfdcNotes?.salesQualificationNotes ?? '';
    const [salesQualificationCopied, setSalesQualificationCopied] = useState(false);
    const copyResetTimeoutRef = useRef<number | null>(null);

    useEffect(() => {
        return () => {
            if (copyResetTimeoutRef.current != null) {
                window.clearTimeout(copyResetTimeoutRef.current);
            }
        };
    }, []);

    const handleCopySalesQualificationNotes = async () => {
        if (!salesQualificationNotes) return;
        await navigator.clipboard.writeText(salesQualificationNotes);
        setSalesQualificationCopied(true);

        if (copyResetTimeoutRef.current != null) {
            window.clearTimeout(copyResetTimeoutRef.current);
        }
        copyResetTimeoutRef.current = window.setTimeout(() => {
            setSalesQualificationCopied(false);
        }, 1200);
    };

    const columns = [
        {
            title: 'SFDC',
            dataIndex: 'items',
            width: '100%',
            render: (value: any) => renderPairItem(value[0]),
        },
    ];

    const items = [
        {
            items: [
                {
                    name: 'Credit / Finance Notes',
                    value: notes.sfdcNotes?.creditFinanceNotes,
                },
            ],
        },
        {
            items: [
                {
                    name: 'Sales Notes - Qualification Note',
                    value: (
                        <div style={{display: 'flex', alignItems: 'flex-start', gap: 12}}>
                            <Typography.Text style={{whiteSpace: 'pre-wrap', flex: 1}}>
                                {salesQualificationNotes || null}
                            </Typography.Text>
                            {salesQualificationNotes ? (
                                <Tooltip title={salesQualificationCopied ? 'Copied' : 'Copy'}>
                                    <Button
                                        type="text"
                                        onClick={handleCopySalesQualificationNotes}
                                        icon={
                                            salesQualificationCopied
                                                ? <CheckOutlined style={{fontSize: 18, color: '#22c55e'}} />
                                                : <CopyOutlined style={{fontSize: 18}} />
                                        }
                                    />
                                </Tooltip>
                            ) : null}
                        </div>
                    ),
                },
            ],
        },
        {
            items: [
                {
                    name: 'Sales Notes - Direct Lead Customer Notes',
                    value: notes.sfdcNotes?.salesDirectLeadCustomerNotes,
                },
            ],
        },
        {
            items: [
                {
                    name: 'Sales Notes - Salesperson Notes',
                    value: notes.sfdcNotes?.salesPersonNotes,
                },
            ],
        },
    ];

    return (
        <Table
            size={'small'}
            pagination={false}
            // @ts-ignore
            columns={columns}
            dataSource={items}/>
    );
};